export const getRequestedUsername = (search: string) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get('userName') || searchParams.get('username') || undefined;
};
